import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { AuthGuard, I18nModule, UrlModule, provideConfig } from '@spartacus/core';
import {
  IconModule,
  MediaModule,
  OutletModule,
  OutletRefModule,
  PageLayoutModule,
  PageSlotModule,
} from '@spartacus/storefront';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { KbCustomerIdDropdownModule } from '../kb-MyOwnPartNumbers/customer-id-drop-down/customer-id-drop-down.module';
import { KbMyAccountLeftSideNavModule } from '../my-account-left-sidenav/my-account-left-sidenav.module';
import { KbMyOwnPartNumbersModule } from '../kb-MyOwnPartNumbers/kbMyOwnPartNumbers.module';
import { CoreSearchComponent } from './core-search/core-search.component';
import { SecureGuard } from 'src/app/services/Guards/secure.service';
import { KbPaginationModule } from '../../kb-pagination/kb-pagination/kb-pagination.module';

@NgModule({
  imports: [
    CommonModule,
    CommonModule,
    RouterModule,
    UrlModule,
    IconModule,
    I18nModule,
    MatDialogModule,
    MatButtonModule,
    MediaModule,
    BsDatepickerModule,
    FormsModule,
    ReactiveFormsModule,
    KbCustomerIdDropdownModule,
    KbPaginationModule,
    PageLayoutModule,
    OutletModule,
    OutletRefModule,
    KbMyOwnPartNumbersModule,
    PageSlotModule,
    KbMyAccountLeftSideNavModule,
  ],
  exports: [CoreSearchComponent],
  declarations: [CoreSearchComponent],
  providers: [
    provideConfig({
      cmsComponents: {
        KbCoreSearchReturnFlexComponent: {
          component: CoreSearchComponent,
          guards: [SecureGuard, AuthGuard]
        },
      },
    }),
  ],
})
export class CoreSearchModule { }
